export enum PartnerRole {
  OPS = 'partner_ops',
  FINANCE = 'partner_finance'
}

export const ALL_PARTNER_ROLES: PartnerRole[] = [PartnerRole.OPS, PartnerRole.FINANCE]

export const PARTNER_ROLE_LABELS: Record<PartnerRole, string> = {
  [PartnerRole.OPS]: 'Operations',
  [PartnerRole.FINANCE]: 'Finance'
}

export const formatRequiredRolesMessage = (roles: PartnerRole[]): string => {
  const labels = roles.map((role) => PARTNER_ROLE_LABELS[role])
  if (labels.length === 0) return ''
  if (labels.length === 1) return `Requires the ${labels[0]} role`
  if (labels.length === 2) return `Requires the ${labels[0]} or ${labels[1]} role`
  return `Requires one of: ${labels.join(', ')}`
}

// Cognito stores group membership in the `cognito:groups` claim. Keep only the partner roles we recognise.
export const extractPartnerRoles = (groups: string[] | undefined | null): PartnerRole[] => {
  if (!groups) return []
  return ALL_PARTNER_ROLES.filter((role) => groups.includes(role))
}
